import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import classNames from 'classnames'

import { pageChanged, startPageLoading, stopPageLoading, updatePageState } from '../../../../data/redux/page_details/actions';
import { getAllGroups, getAgentCannedResponses, updateTransferChatData, emitMemberCustomEvent } from '../../../../data/redux/member_details/actions';
import { getAgentLiveKpis } from '../../../../data/redux/kpi_details/actions'
import { getAllIntents, getAllEntities } from '../../../../data/redux/nlp_details/actions';
import { joinChatsPage, emitChatsCustomEvent, joinChatRoom } from '../../../../data/redux/chats_details/actions';
import { getIsEmptyGroupList } from '../../../../data/redux/member_details/selectors';

import { showMessage } from '../../../../data/config/utils';
import { APP_PAGES, APP_LAYOUT, SOCKET_EVENTS } from '../../../../data/config/constants';
import { MODULE_CONFIG } from '../../../../data/config/urls'

import ChatList from './components/chatlist';
import ChatWindow from './components/chatwindow';
import ClientProfile from './components/clientprofile';
import ChatDrawer from './components/chatdrawer';

class Chats extends React.PureComponent {
  constructor(props) {
    super(props);
    this.agent_kpi_timer = null
    this.state = {
      drawer_data: {
        title: "",
        show_transfer_chat: false,
      }
    }
  }

  componentDidMount() {
    const { actions, admin_email, admin_id, is_chats_socket_connected } = this.props;
    actions.pageChanged(APP_PAGES.CHATS, APP_PAGES.CHATS);
    actions.getAllIntents();
    actions.getAllEntities();
    actions.getAllGroups();
    if (admin_email) {
      const payload = { email: admin_email }
      actions.getAgentCannedResponses(payload);
    }
    if (is_chats_socket_connected)
      actions.joinChatsPage()
    if (this.agent_kpi_timer)
      clearInterval(this.agent_kpi_timer);
    actions.getAgentLiveKpis({ agentPsid: admin_id });
    this.agent_kpi_timer = setInterval(() => actions.getAgentLiveKpis({ agentPsid: admin_id }), MODULE_CONFIG.GLOBAL.AGENT_LIVE_KPI_POLLING_INTERVAL);
  }

  componentDidUpdate(prevProps) {
    const { is_chats_socket_connected, actions } = this.props;
    if (!prevProps.is_chats_socket_connected && is_chats_socket_connected)
      actions.joinChatsPage();
  }

  componentWillUnmount() {
    const { actions } = this.props;
    actions.emitChatsCustomEvent(SOCKET_EVENTS.LEAVE, {});
    if (this.agent_kpi_timer)
      clearInterval(this.agent_kpi_timer);
  }

  joinChatRoom = chat_info => {
    const { actions, admin_id } = this.props;
    const payload = {
      clientPsid: chat_info.psid,
      adminPsid: admin_id
    }
    actions.joinChatRoom(payload)
  }

  joinAgentTransfer = () => {
    const { actions, selected_active_chat_id } = this.props;
    if (selected_active_chat_id) {
      const payload = { clientPsid: selected_active_chat_id };
      actions.emitMemberCustomEvent(SOCKET_EVENTS.JOIN_AGENT_TRANSFER, payload, (err, res) => {
        if (!err && res && res.data) {
          actions.updateTransferChatData(res.data);
          this.setState({
            drawer_data: {
              title: "Transfer Chat",
              show_transfer_chat: true,
            }
          });
        } else
          showMessage('error', res && res.message ? res.message : "join agent transfer event error occured");
      });
    }
  };

  closeDrawer = () => {
    this.setState({
      drawer_data: {
        title: "",
        show_transfer_chat: false,
      }
    });
  };

  openTransferChatDrawer = () => {
    const { actions, is_group_list_empty } = this.props;
    if (is_group_list_empty) {
      actions.startPageLoading("group list loading");
      actions.getAllGroups(() => {
        actions.stopPageLoading();
        this.joinAgentTransfer();
      });
    } else
      this.joinAgentTransfer();
  };

  render() {
    const { screen_width, screen_height, actions, isActionPermitted, history } = this.props;
    const { drawer_data } = this.state;
    const is_mobile = screen_width < 768;
    return (
      <Row
        className={classNames("ori-animated ori-fade-in ori-overflow-hidden",
          {
            "ori-bg-white": !is_mobile
          }
        )}
        style={screen_width < 768 ? {} : { height: `${screen_height - APP_LAYOUT.APP_HEADER_HEIGHT}px` }}
      >
        <Col
          xs={24}
          md={6}
          id='chatList'
          className={`${is_mobile ? "ori-bg-white ori-b-mrgn-10 ori-b-pad-10" : "ori-full-parent-height ori-r-border-light"}`}
        >
          <ChatList refreshChatList={actions.joinChatsPage} />
        </Col>
        <ChatWindow
          isActionPermitted={isActionPermitted}
          joinChatRoom={this.joinChatRoom}
          openTransferChatDrawer={this.openTransferChatDrawer}
        />
        <ClientProfile navigateTo={history.push} />
        <ChatDrawer drawer_data={drawer_data} closeDrawer={this.closeDrawer} />
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    screen_height: state.page_details.device_data.screen_height,
    screen_width: state.page_details.device_data.screen_width,
    is_chats_socket_connected: state.chats_details.is_socket_connected,
    selected_active_chat_id: state.chats_details.selected_active_chat_id,
    admin_id: state.admin_details.admin_id,
    admin_email: state.admin_details.user_info ? state.admin_details.user_info.email : null,
    is_group_list_empty: getIsEmptyGroupList(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        pageChanged,
        startPageLoading,
        stopPageLoading,
        updatePageState,
        getAllIntents,
        getAllEntities,
        getAllGroups,
        getAgentCannedResponses,
        joinChatsPage,
        emitChatsCustomEvent,
        joinChatRoom,
        updateTransferChatData,
        emitMemberCustomEvent,
        getAgentLiveKpis
      },
      dispatch),
  };
};

Chats.propTypes = {
  screen_height: PropTypes.number,
  screen_width: PropTypes.number,
  admin_id: PropTypes.string,
  admin_email: PropTypes.string,
  is_chats_socket_connected: PropTypes.bool,
  selected_active_chat_id: PropTypes.string,
  is_group_list_empty: PropTypes.bool,
  history: PropTypes.object,
  actions: PropTypes.object,
  isActionPermitted: PropTypes.func,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Chats));



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/chats/index.js